import { isString } from './assertion.library.js';
/**
 * Global Error Boundary Utility.
 * Decouples the decision to throw an error from the act of logging it.
 *
 * @param err - The Error object or error string to raise
 * @param context - Optional boundary context configuration
 * @example
 * ```ts
 * raise('Invalid input', { catch: true, logger: myLogger });
 * ```
 */
export function raise(err, context = {}) {
    const error = isString(err) ? new Error(err) : err;
    // 1. Output the error telemetry
    if (!context.silent) {
        if (context.logger) {
            context.logger.error(error);
        }
        else {
            console.error('[Boundary]', error);
        }
    }
    // 2. Control flow
    if (context.catch)
        return; // gracefully swallow the error
    throw error;
}
